// Dienst + plaats landingspagina's (bijv. "kozijnen Dordrecht").
export interface DienstLocatieContent {
  /** URL-pad zonder slash, bijv. "kozijnen-dordrecht". */
  slug: string;
  dienst: string;
  dienstSlug: string;
  plaats: string;
  h1: string;
  eyebrow: string;
  title: string;
  description: string;
  socialTitle: string;
  socialDescription: string;
  intro: string;
  paragraphs: string[];
  prijsLabel: string;
  prijs: string;
  prijsNoot: string;
  usps: string[];
  wijken?: string[];
  faq: { vraag: string; antwoord: string }[];
  /** Kostengids waar deze pagina naar doorlinkt. */
  kostenPad?: KostenPad;
  /** Plaatspagina waar deze pagina naar doorlinkt. */
  locatiePad?: LocatiePad;
}

export type KostenPad =
  | "/kozijnen-kosten"
  | "/dakkapel-kosten"
  | "/renovatie-kosten"
  | "/aanbouw-kosten"
  | "/kosten";

export type LocatiePad =
  | "/timmerman-dordrecht"
  | "/timmerman-zwijndrecht"
  | "/timmerman-papendrecht"
  | "/timmerman-sliedrecht";


export const kozijnenDordrecht: DienstLocatieContent = {
  slug: "kozijnen-dordrecht",
  dienst: "Kozijnen",
  dienstSlug: "kozijnen",
  plaats: "Dordrecht",
  eyebrow: "Kozijnen Dordrecht",
  h1: "Kozijnen Dordrecht — vervangen en plaatsen op maat",
  title: "Kozijnen Dordrecht | Kozijnen vervangen vanaf € 900",
  description:
    "Kozijnen vervangen in Dordrecht? Fedor Timmerwerken plaatst houten, kunststof en aluminium kozijnen met HR++ glas. Richtprijs € 900 – € 1.800 per kozijn.",
  socialTitle: "Kozijnen Dordrecht | Fedor Timmerwerken",
  socialDescription:
    "Houten, kunststof en aluminium kozijnen met HR++ glas, op maat gemaakt en geplaatst in Dordrecht.",
  intro:
    "Fedor Timmerwerken vervangt en plaatst kozijnen in heel Dordrecht. We maken het houtwerk op maat, plaatsen HR++ of triple glas en werken de aansluitingen netjes af — binnen en buiten.",
  paragraphs: [
    "Veel Dordtse woningen hebben nog kozijnen uit de jaren '60 tot '80: enkel glas of verouderd dubbelglas, klemmende ramen en houtrot bij de onderdorpels. In de vooroorlogse wijken rond de binnenstad komt daar vaak nog een monument- of beschermd stadsgezicht bij, waardoor de detaillering en het profiel van het kozijn moeten kloppen. Wij maken die kozijnen na, zodat het aanzicht van de woning blijft zoals het was maar de isolatie van nu is.",
    "We werken zowel per kozijn als voor de hele woning. Bij een complete vervanging plannen we per verdieping, zodat je woning nooit langer dan nodig open staat. Sloopwerk, aftimmeren, kit- en stucwerk en het afvoeren van het oude materiaal zitten in de offerte — geen verrassingen achteraf.",
    "Nieuwe kozijnen met isolerend glas vallen onder verduurzaming. Onze offerte en factuur zijn zo opgesteld dat je ze direct kunt gebruiken voor je subsidieaanvraag of een verduurzamingslening bij de gemeente Dordrecht.",
  ],
  prijsLabel: "Richtprijs per kozijn in Dordrecht",
  prijs: "€ 900 – € 1.800",
  prijsNoot:
    "Inclusief HR++ glas, plaatsing, aftimmeren en afvoeren van het oude kozijn. Grote of samengestelde kozijnen en gevelvullende puien liggen hoger.",
  usps: [
    "Gratis opname en advies aan huis in Dordrecht",
    "Hout, kunststof en aluminium — ook profielen op maat",
    "HR++ standaard, triple glas mogelijk",
    "Geschikt voor subsidieaanvraag verduurzaming",
  ],
  wijken: [
    "Binnenstad",
    "Het Reeland",
    "Krispijn",
    "Dubbeldam",
    "Stadspolders",
    "Sterrenburg",
    "Wielwijk",
    "Crabbehof",
  ],
  faq: [
    {
      vraag: "Wat kost het vervangen van kozijnen in Dordrecht?",
      antwoord:
        "Reken op € 900 tot € 1.800 per kozijn, inclusief HR++ glas en plaatsing. Voor een tussenwoning met 6 tot 10 kozijnen komt dat neer op circa € 5.400 tot € 18.000. Gevelvullende puien en samengestelde kozijnen worden apart begroot.",
    },
    {
      vraag: "Heb ik een vergunning nodig voor nieuwe kozijnen in Dordrecht?",
      antwoord:
        "Vervang je kozijnen in dezelfde maat, indeling en kleur, dan is dat meestal vergunningvrij. In het beschermd stadsgezicht van de Dordtse binnenstad en bij monumenten geldt dat niet: dan is een omgevingsvergunning nodig. We controleren dit vooraf en leveren de tekeningen aan.",
    },
    {
      vraag: "Hoe lang duurt het vervangen van kozijnen?",
      antwoord:
        "Per kozijn duurt het plaatsen en afwerken doorgaans een halve tot een hele dag. Een complete woning doen we meestal in 3 tot 6 werkdagen, per verdieping ingepland zodat je woning niet open blijft staan.",
    },
    {
      vraag: "Kies ik in Dordrecht beter hout of kunststof?",
      antwoord:
        "Hout past het beste bij vooroorlogse woningen en in het beschermd stadsgezicht, omdat we het profiel exact kunnen nabootsen. Kunststof is onderhoudsarm en vaak de logische keuze in wijken als Sterrenburg en Stadspolders. We bespreken beide opties tijdens de opname.",
    },
    {
      vraag: "Is er subsidie voor nieuwe kozijnen?",
      antwoord:
        "Ja, kozijnen met HR++ of triple glas tellen mee als isolatiemaatregel. Combineer je dit met een tweede maatregel, zoals dak- of vloerisolatie, dan valt de subsidie hoger uit. Onze facturen bevatten de gegevens die daarvoor nodig zijn.",
    },
  ],
};

export const dakkapelDordrecht: DienstLocatieContent = {
  slug: "dakkapel-dordrecht",
  dienst: "Dakkapel",
  dienstSlug: "dakkapel",
  plaats: "Dordrecht",
  eyebrow: "Dakkapel Dordrecht",
  h1: "Dakkapel Dordrecht — op maat gemaakt en geplaatst",
  title: "Dakkapel Dordrecht | Dakkapel plaatsen vanaf € 7.500",
  description:
    "Dakkapel plaatsen in Dordrecht? Fedor Timmerwerken maakt dakkapellen op maat in eigen werkplaats. Richtprijs € 7.500 – € 15.000, inclusief plaatsing en afwerking.",
  socialTitle: "Dakkapel Dordrecht | Fedor Timmerwerken",
  socialDescription:
    "Dakkapellen op maat voor Dordrechtse woningen — geplaatst en afgewerkt in 3 tot 5 dagen.",
  intro:
    "Fedor Timmerwerken plaatst dakkapellen in heel Dordrecht. We maken de dakkapel op maat, plaatsen hem meestal in één dag op het dak en werken de binnenzijde compleet af — van isolatie tot aftimmerwerk.",
  paragraphs: [
    "In Dordrecht staan veel rijwoningen uit de jaren '60 tot '80 met een onbenutte zolder. Een dakkapel over de volle breedte levert daar vaak 6 tot 10 m² extra bruikbaar vloeroppervlak op: genoeg voor een derde slaapkamer of een werkkamer met een normale stahoogte.",
    "Wij bouwen het element in de werkplaats op, zodat de woning maar kort open staat. Op de plaatsdag verwijderen we de pannen, zagen de sparing, hijsen de dakkapel erin en maken het geheel dezelfde dag wind- en waterdicht. Daarna volgen de binnenafwerking, isolatie en het aftimmeren van de dagkanten.",
    "Voor woningen in het beschermd stadsgezicht en bij monumenten in de binnenstad kijken we eerst naar de vergunningsplicht en de gewenste detaillering. Aan de achterzijde van een woning in Sterrenburg, Stadspolders of Dubbeldam is een dakkapel meestal vergunningvrij.",
  ],
  prijsLabel: "Richtprijs dakkapel in Dordrecht",
  prijs: "€ 7.500 – € 15.000",
  prijsNoot:
    "Voor een dakkapel van circa 2 tot 4 meter breed, inclusief plaatsing, isolatie en binnenafwerking. Steiger of hoogwerker afhankelijk van de bereikbaarheid.",
  usps: [
    "Gratis opname en advies aan huis in Dordrecht",
    "Op maat gemaakt in eigen werkplaats",
    "In één dag wind- en waterdicht op het dak",
    "Vergunningcheck en tekeningen worden geregeld",
  ],
  wijken: [
    "Sterrenburg",
    "Stadspolders",
    "Dubbeldam",
    "Krispijn",
    "Wielwijk",
    "Crabbehof",
    "Het Reeland",
    "Binnenstad",
  ],
  kostenPad: "/dakkapel-kosten",
  locatiePad: "/timmerman-dordrecht",
  faq: [
    {
      vraag: "Wat kost een dakkapel in Dordrecht?",
      antwoord:
        "Reken op € 7.500 tot € 15.000 voor een dakkapel van 2 tot 4 meter breed, inclusief plaatsing, isolatie en binnenafwerking. Een dakkapel over de volle breedte van een rijwoning ligt doorgaans rond € 12.000 tot € 15.000.",
    },
    {
      vraag: "Is een dakkapel in Dordrecht vergunningvrij?",
      antwoord:
        "Aan de achterzijde van de woning is een dakkapel vaak vergunningvrij, mits die minimaal 0,5 meter onder de nok en 0,5 meter boven de dakvoet blijft. In het beschermd stadsgezicht en bij monumenten is wel een omgevingsvergunning nodig. Wij controleren dit vooraf bij de gemeente Dordrecht.",
    },
    {
      vraag: "Hoe lang duurt het plaatsen van een dakkapel?",
      antwoord:
        "De dakkapel wordt in de werkplaats voorbereid en op de plaatsdag in één dag wind- en waterdicht gemaakt. Inclusief isolatie en binnenafwerking bent u doorgaans 3 tot 5 werkdagen bezig.",
    },
    {
      vraag: "Hoeveel ruimte levert een dakkapel op?",
      antwoord:
        "Bij een gemiddelde Dordtse rijwoning levert een dakkapel over de volle breedte 6 tot 10 m² extra bruikbare vloeroppervlakte op, met een stahoogte van ruim 2,20 meter.",
    },
  ],
};

export const aanbouwDordrecht: DienstLocatieContent = {
  slug: "aanbouw-dordrecht",
  dienst: "Aanbouw",
  dienstSlug: "aanbouw",
  plaats: "Dordrecht",
  eyebrow: "Aanbouw Dordrecht",
  h1: "Aanbouw Dordrecht — uitbouw op maat aan uw woning",
  title: "Aanbouw Dordrecht | Uitbouw vanaf € 1.800 per m²",
  description:
    "Aanbouw of uitbouw in Dordrecht? Fedor Timmerwerken verzorgt fundering, ruwbouw, dak en kozijnen. Richtprijs € 1.800 – € 3.200 per m², inclusief vergunningcheck.",
  socialTitle: "Aanbouw Dordrecht | Fedor Timmerwerken",
  socialDescription:
    "Uitbouw op maat in Dordrecht — van fundering tot oplevering, met vaste prijs per m².",
  intro:
    "Fedor Timmerwerken bouwt aanbouwen en uitbouwen in heel Dordrecht. Van fundering en ruwbouw tot dak, schuifpui en afwerking — één aanspreekpunt en een vaste prijs per m².",
  paragraphs: [
    "Een aanbouw aan de achterzijde is in Dordrecht de snelste manier om de woonkeuken te vergroten. De meest gekozen maat is 3 tot 4 meter diep over de volle breedte van de woning, met een gevelbrede schuifpui naar de tuin.",
    "Dordrecht heeft op veel plekken een slappe ondergrond. In wijken als Stadspolders, Sterrenburg en Wielwijk is daardoor vaak een paalfundering nodig, wat de kosten met circa € 4.000 tot € 9.000 verhoogt. Wij laten dit vooraf beoordelen zodat de offerte klopt met de werkelijkheid.",
    "Tot 4 meter diep is een aanbouw aan de achterzijde in veel gevallen vergunningvrij binnen het achtererfgebied. We toetsen de situatie aan het omgevingsplan van de gemeente Dordrecht en verzorgen desnoods de tekeningen en de aanvraag.",
  ],
  prijsLabel: "Richtprijs aanbouw in Dordrecht",
  prijs: "€ 1.800 – € 3.200 per m²",
  prijsNoot:
    "Inclusief fundering, ruwbouw, plat dak met EPDM en kozijnen met HR++ glas. Exclusief keuken, meubels en eventuele paalfundering.",
  usps: [
    "Gratis opname en bouwadvies aan huis",
    "Vergunningcheck en tekeningen bij de gemeente Dordrecht",
    "Rekening houdend met paalfundering bij slappe bodem",
    "Van fundering tot oplevering door één partij",
  ],
  wijken: [
    "Stadspolders",
    "Sterrenburg",
    "Dubbeldam",
    "Krispijn",
    "Wielwijk",
    "Crabbehof",
    "Het Reeland",
    "Binnenstad",
  ],
  kostenPad: "/aanbouw-kosten",
  locatiePad: "/timmerman-dordrecht",
  faq: [
    {
      vraag: "Wat kost een aanbouw in Dordrecht?",
      antwoord:
        "Reken op € 1.800 tot € 3.200 per m². Een aanbouw van 20 m² komt daarmee op circa € 36.000 tot € 64.000. Is een paalfundering nodig, dan komt daar € 4.000 tot € 9.000 bij.",
    },
    {
      vraag: "Is een aanbouw in Dordrecht vergunningvrij?",
      antwoord:
        "Aan de achterzijde is een aanbouw tot 4 meter diep vaak vergunningvrij binnen het achtererfgebied, mits de bebouwing binnen de toegestane oppervlakte blijft. In het beschermd stadsgezicht van de binnenstad geldt dat niet. Wij controleren dit bij de gemeente.",
    },
    {
      vraag: "Heb ik in Dordrecht een paalfundering nodig?",
      antwoord:
        "Vaak wel. Grote delen van Dordrecht hebben een slappe ondergrond, waardoor een fundering op staal onvoldoende is. We laten de bodem vooraf beoordelen en nemen de juiste fundering direct in de offerte mee.",
    },
    {
      vraag: "Hoe lang duurt het bouwen van een aanbouw?",
      antwoord:
        "Een aanbouw van 15 tot 25 m² duurt gemiddeld 6 tot 10 weken, inclusief fundering, ruwbouw, dak, kozijnen en afwerking. Bij een vergunningsplichtige aanbouw komt de doorlooptijd van de aanvraag daar nog bij.",
    },
  ],
};

export const kozijnenZwijndrecht: DienstLocatieContent = {
  slug: "kozijnen-zwijndrecht",
  dienst: "Kozijnen",
  dienstSlug: "kozijnen",
  plaats: "Zwijndrecht",
  eyebrow: "Kozijnen Zwijndrecht",
  h1: "Kozijnen Zwijndrecht — vervangen en plaatsen op maat",
  title: "Kozijnen Zwijndrecht | Kozijnen vervangen vanaf € 900",
  description:
    "Kozijnen vervangen in Zwijndrecht? Fedor Timmerwerken plaatst houten, kunststof en aluminium kozijnen met HR++ glas. Richtprijs € 900 – € 1.800 per kozijn.",
  socialTitle: "Kozijnen Zwijndrecht | Fedor Timmerwerken",
  socialDescription:
    "Kozijnen op maat met HR++ glas, geplaatst en afgewerkt in Zwijndrecht en Heerjansdam.",
  intro:
    "Fedor Timmerwerken vervangt kozijnen in Zwijndrecht en omgeving. We maken het houtwerk op maat, plaatsen HR++ of triple glas en werken alles binnen en buiten netjes af — vanuit Dordrecht op tien minuten rijden.",
  paragraphs: [
    "Veel woningen in Zwijndrecht-Noord, Walburg en Kort Ambacht hebben kozijnen uit de jaren '60 en '70. Houtrot bij de onderdorpels, klemmende ramen en verouderd dubbelglas zijn daar de meest voorkomende klachten. Wij vervangen per kozijn of in één keer de hele woning.",
    "Bij een complete vervanging werken we per verdieping: de oude kozijnen eruit, direct het nieuwe element erin, afkitten en aftimmeren. Zo blijft uw woning nooit langer open dan nodig. Sloopwerk, afwerking en het afvoeren van oud materiaal zitten in de offerte.",
    "Nieuwe kozijnen met isolerend glas tellen mee als isolatiemaatregel. Onze offerte en factuur bevatten de gegevens die u nodig hebt voor een subsidieaanvraag of een verduurzamingslening.",
  ],
  prijsLabel: "Richtprijs per kozijn in Zwijndrecht",
  prijs: "€ 900 – € 1.800",
  prijsNoot:
    "Inclusief HR++ glas, plaatsing, aftimmeren en afvoeren van het oude kozijn. Gevelvullende puien en samengestelde kozijnen worden apart begroot.",
  usps: [
    "Gratis opname en advies aan huis in Zwijndrecht",
    "Hout, kunststof en aluminium — ook profielen op maat",
    "HR++ standaard, triple glas mogelijk",
    "Geschikt voor subsidieaanvraag verduurzaming",
  ],
  wijken: ["Walburg", "Kort Ambacht", "Nederhoven", "Heer Oudelands Ambacht", "Heerjansdam"],
  kostenPad: "/kozijnen-kosten",
  locatiePad: "/timmerman-zwijndrecht",
  faq: [
    {
      vraag: "Wat kost het vervangen van kozijnen in Zwijndrecht?",
      antwoord:
        "Reken op € 900 tot € 1.800 per kozijn, inclusief HR++ glas en plaatsing. Voor een tussenwoning met 6 tot 10 kozijnen komt dat neer op circa € 5.400 tot € 18.000.",
    },
    {
      vraag: "Heb ik een vergunning nodig voor nieuwe kozijnen in Zwijndrecht?",
      antwoord:
        "Vervangt u de kozijnen in dezelfde maat, indeling en kleur, dan is dat meestal vergunningvrij. Wij toetsen de situatie aan het omgevingsplan van de gemeente Zwijndrecht voordat we starten.",
    },
    {
      vraag: "Komt u ook in Heerjansdam en Hendrik-Ido-Ambacht?",
      antwoord:
        "Ja. Vanuit Dordrecht werken we in heel Zwijndrecht, inclusief Heerjansdam, en in Hendrik-Ido-Ambacht. Er worden geen extra voorrijkosten gerekend binnen de Drechtsteden.",
    },
    {
      vraag: "Hout of kunststof kozijnen?",
      antwoord:
        "Hout laat zich exact op profiel maken en past het beste bij oudere woningen; kunststof is onderhoudsarm en vaak de logische keuze in naoorlogse wijken als Walburg en Kort Ambacht. We bespreken beide opties tijdens de opname.",
    },
  ],
};

export const schuurTuinhuisDordrecht: DienstLocatieContent = {
  slug: "schuur-tuinhuis-laten-bouwen",
  dienst: "Schuur of tuinhuis",
  dienstSlug: "schuur",
  plaats: "Dordrecht",
  eyebrow: "Schuur of tuinhuis op maat",
  h1: "Schuur of tuinhuis laten bouwen in Dordrecht en de Drechtsteden",
  title: "Schuur of tuinhuis laten bouwen | Fedor Timmerwerken",
  description:
    "Houten schuur of tuinhuis op maat laten bouwen in Dordrecht? Vergunningsvrij advies, fundering en plaatsing door één timmerman. Richtprijs vanaf € 650 per m².",
  socialTitle: "Schuur of tuinhuis laten bouwen | Fedor Timmerwerken",
  socialDescription:
    "Geen zin om zelf te klussen? Fedor bouwt je houten schuur of tuinhuis op maat, inclusief fundering en vergunningscheck.",
  intro:
    "Geen zin om zelf te klussen met een bouwpakket? Wij bouwen je houten schuur, tuinhuis of berging volledig op maat: fundering, constructie, dak, deuren en afwerking — in één keer goed.",
  paragraphs: [
    "Vergunningsvrij bouwen kan in de achtertuin vaak tot een flink formaat. Grofweg geldt: een bijbehorend bouwwerk mag maximaal 3 meter hoog zijn (of tot 30 cm boven de vloer van de eerste verdieping bij aanbouw), en hoeveel m² je vergunningsvrij mag bebouwen hangt af van de grootte van je achtererfgebied — bij een erf tot 100 m² is dat de helft, met extra ruimte bij grotere tuinen. Wij checken dit vooraf voor jouw perceel, zodat je niet voor verrassingen komt te staan.",
    "Een prefab bouwpakket lijkt goedkoop, maar zonder goede fundering, waterdichte dakafwerking en rechte stelling gaat het binnen een paar jaar scheef of lekken. Wij werken met duurzaam hout zoals douglas, lariks of thermisch gemodificeerd hout, en bouwen op betonpoeren of een gestorte plaat.",
    "Of het nu een simpele berging is, een tuinhuis met overkapping of een geïsoleerde tuinkamer als werkplek: je krijgt vooraf een vaste prijs en een duidelijke planning. De meeste schuren staan binnen 3 tot 5 werkdagen.",
  ],
  prijsLabel: "Richtprijs schuur of tuinhuis",
  prijs: "€ 650 – € 1.400 per m²",
  prijsNoot:
    "Een eenvoudige houten berging van 6 m² kost ongeveer € 4.000 – € 6.500; een geïsoleerd tuinhuis met overkapping van 15 m² ongeveer € 12.000 – € 20.000. Inclusief fundering, montage en btw.",
  usps: [
    "Vergunningscheck vooraf voor jouw tuin",
    "Fundering, bouw en afwerking door één vakman",
    "Duurzaam hout: douglas, lariks of thermowood",
    "Vaste prijs en meestal binnen 3–5 werkdagen klaar",
  ],
  wijken: ["Dordrecht", "Zwijndrecht", "Papendrecht", "Sliedrecht", "Hendrik-Ido-Ambacht", "Alblasserdam"],
  faq: [
    {
      vraag: "Hoe groot mag je een schuur bouwen zonder vergunning?",
      antwoord:
        "In het achtererfgebied mag een schuur vergunningsvrij maximaal 3 meter hoog zijn. Bij een achtererf tot 100 m² mag je de helft bebouwen; bij grotere tuinen komt er extra ruimte bij, tot een maximum van 150 m². Een monument, beschermd stadsgezicht of het omgevingsplan kan andere regels geven — wij checken dat vooraf.",
    },
    {
      vraag: "Wat kost een schuur laten bouwen?",
      antwoord:
        "Reken op € 650 – € 1.400 per m², afhankelijk van houtsoort, isolatie, fundering en deuren/ramen. Een berging van 6 m² kost ongeveer € 4.000 – € 6.500 inclusief plaatsing.",
    },
    {
      vraag: "Welke fundering is nodig voor een tuinhuis?",
      antwoord:
        "Voor een kleine berging volstaan betonpoeren of een tegelfundering op verdicht zand. Voor een groter of geïsoleerd tuinhuis adviseren we een gestorte betonplaat of schroeffundering, zodat het niet verzakt in de Dordtse kleigrond.",
    },
    {
      vraag: "Kunnen jullie ook een tuinhuis met overkapping bouwen?",
      antwoord:
        "Ja. Een tuinhuis met aangebouwde overkapping of veranda maken we volledig op maat, ook in combinatie met een vlonder.",
    },
  ],
  kostenPad: "/kosten",
};

export const verbouwingDordrecht: DienstLocatieContent = {
  slug: "verbouwing-dordrecht",
  dienst: "Verbouwing en renovatie",
  dienstSlug: "renovatie",
  plaats: "Dordrecht",
  eyebrow: "Verbouwing & renovatie Dordrecht",
  h1: "Verbouwing en renovatie in Dordrecht — van ontwerp tot oplevering",
  title: "Verbouwing Dordrecht | Renovatie door Fedor Timmerwerken",
  description:
    "Woning verbouwen of renoveren in Dordrecht? Fedor Timmerwerken regelt timmerwerk, wanden, plafonds, vloeren en isolatie. Gratis opname en vaste prijs.",
  socialTitle: "Verbouwing & renovatie Dordrecht | Fedor Timmerwerken",
  socialDescription:
    "Complete verbouwingen en renovaties in Dordrecht: één aanspreekpunt, vaste prijs en vakwerk.",
  intro:
    "Van een nieuwe indeling tot een complete renovatie van je woning: Fedor Timmerwerken verbouwt in heel Dordrecht met één vast aanspreekpunt, een heldere planning en een vaste prijs.",
  paragraphs: [
    "Dordrecht heeft een gevarieerde woningvoorraad: vooroorlogse panden in de binnenstad en Bleijenhoek, jaren '30-woningen in Oud-Krispijn en rijtjeshuizen uit de jaren '60 en '70 in Crabbehof, Sterrenburg en Dubbeldam. Elk type vraagt om een andere aanpak — van het herstellen van oude balklagen tot het isoleren van een spouw of het verwijderen van een dragende wand.",
    "Wij nemen het timmerwerk voor onze rekening: wanden verplaatsen of plaatsen, plafonds en vloeren vernieuwen, trappen, kozijnen en deuren, en het isoleren van dak, vloer en gevel. Voor installatie- en tegelwerk werken we met vaste partners, zodat je niet zelf met vijf vakmensen hoeft te schakelen.",
    "Na een gratis opname bij je thuis krijg je een gespecificeerde offerte. Verduurzamingsonderdelen staan apart vermeld, zodat je ze direct kunt gebruiken voor subsidie of een verduurzamingslening.",
  ],
  prijsLabel: "Richtprijs verbouwing",
  prijs: "€ 400 – € 1.200 per m²",
  prijsNoot:
    "Een lichte renovatie (wanden, plafonds, vloeren) begint rond € 400 per m²; een complete renovatie inclusief isolatie en nieuwe indeling loopt op tot € 1.200 per m². Inclusief btw.",
  usps: [
    "Gratis opname en gespecificeerde offerte",
    "Eén aanspreekpunt voor de hele verbouwing",
    "Ervaring met oude Dordtse panden en monumenten",
    "Offerte direct bruikbaar voor subsidie",
  ],
  wijken: ["Binnenstad", "Oud-Krispijn", "Crabbehof", "Sterrenburg", "Dubbeldam", "Stadspolders", "Wielwijk", "Reeland", "Bleijenhoek"],
  faq: [
    {
      vraag: "Wat kost een verbouwing in Dordrecht?",
      antwoord:
        "Afhankelijk van de omvang reken je op € 400 – € 1.200 per m². Een exacte prijs krijg je na een gratis opname bij je thuis.",
    },
    {
      vraag: "Heb ik een vergunning nodig voor mijn verbouwing?",
      antwoord:
        "Interne verbouwingen zijn meestal vergunningsvrij, behalve bij een monument of als je aan de constructie (dragende muren) werkt. Wij zoeken dit vooraf voor je uit.",
    },
    {
      vraag: "Hoe lang duurt een renovatie?",
      antwoord:
        "Een kamer of verdieping duurt meestal 1 tot 3 weken; een complete woningrenovatie 4 tot 10 weken. Je krijgt vooraf een planning per fase.",
    },
  ],
  kostenPad: "/renovatie-kosten",
};
